import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

class CouponCodeRemoveDialog extends React.Component {
  removeCoupon = () => {
    if (!this.props.couponCode) return;

    const {user, firebase} = this.props;

    firebase.database()
      .ref(`couponCodes/${this.props.couponCode}`)
      .remove();

    firebase.database()
      .ref('shopkeepers')
      .child(user.shopkeeperId)
      .child('offers')
      .child(this.props.offerKey)
      .child('couponCode')
      .remove();

    this.props.handleClose(true);
  }
  handleClose = () => {
    this.props.handleClose();
  }

  render()  {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('offer.removeCoupon')}
        primary={true}
        onTouchTap={this.removeCoupon}
      />,
    ];

    return (
      <Dialog title={t('offer.removeCouponFrom')}
        open={this.props.open}
        onRequestClose={this.handleClose}
        actions={actions}>
        {t('offer.deleteCouponDialogText')}
      </Dialog>

    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(CouponCodeRemoveDialog);



// WEBPACK FOOTER //
// ./src/Offer/CouponCodeRemoveDialog.js